module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-subpage-section"
  }, [_c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      staticStyle: {
        "background-color": "black"
      },
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : (item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    })])
  }), 0)], 1)]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a92c6ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopSubpageSection.vue
// module id = 920
// module chunks = 1